import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/system/login',
    method: 'post',
    data
  })
}

export function register(data) {
  return request({
    url: '/system/register',
    method: 'post',
    data
  })
}

export function sendRegisterEmail(data) {
  return request({
    url: '/system/sendRegisterEmail',
    method: 'post',
    data
  })
}

export function getUserInfo() {
  return request({
    url: '/system/user/info',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/system/logout',
    method: 'post'
  })
}

export function updateProfile(data) {
  return request({
    url: '/system/user',
    method: 'put',
    data
  })
}
